import RoomCopy from './RoomCopy';

export default RoomCopy;
